import { render, staticRenderFns } from "./BackMoney.vue?vue&type=template&id=6ef386b9&scoped=true&"
import script from "./BackMoney.vue?vue&type=script&lang=js&"
export * from "./BackMoney.vue?vue&type=script&lang=js&"
import style0 from "./BackMoney.vue?vue&type=style&index=0&id=6ef386b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef386b9",
  null
  
)

component.options.__file = "BackMoney.vue"
export default component.exports